module.exports = __webpack_public_path__ + "static/media/search_user.770cb2a0.svg";